import { Link } from 'react-router-dom';
import { MdDragIndicator } from '@react-icons/all-files/md/MdDragIndicator';
import './styles.scss';

export interface EntityLinkProps {
    to: string;
    label: string;
    entityType?: string;
    withContextHint?: boolean;
}

const EntityLink = ({ to, label, entityType, withContextHint = true }: EntityLinkProps) => (
    <span className="entity-link" data-entity-type={entityType}>
        <Link to={to} className="entity-link__label">
            {label}
        </Link>
        {withContextHint && (
            <MdDragIndicator className="entity-link__hint-icon" aria-hidden="true" />
        )}
    </span>
);

export default EntityLink;
